import React, { useState, useEffect } from 'react';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import useSpotConfig from '@host-panel/request/config/use-config';
import NumericInput from '../common/inputs/customs/num-input-add';

const READ_ONLY_STALENESS_KEY = 'tenant.pitc.staleness';
const DEFAULT_STALE_VALUE = 183;

const SetPitcStaleness = props => {
  const [configValues, setConfig] = useSpotConfig([READ_ONLY_STALENESS_KEY], {
    [READ_ONLY_STALENESS_KEY]: 183
  });

  const [daysUntilStaleness, setDaysUntilStaleness] = useState(DEFAULT_STALE_VALUE);

  useEffect(() => {
    setDaysUntilStaleness(configValues[0] as number);
  }, [configValues]);

  const onSaveDaysUntilStaleness = () => {
    setConfig({ key: READ_ONLY_STALENESS_KEY, value: Number(daysUntilStaleness) });
  };

  const onStalenessNumberChange = (value: number) => {
    setDaysUntilStaleness(value);
  };

  return (
    <NumericInput
      title="Recommended items staleness"
      description="Set the default number of days after which an item will not be recommended"
      onClick={onSaveDaysUntilStaleness}
      onChange={onStalenessNumberChange}
      disabledAddButton={false}
      value={daysUntilStaleness}
    />
  );
};

export default SetPitcStaleness;
